// Single source of truth for the site's URL structure and per-page SEO meta.
// scripts/postbuild-static.mjs generates each route's static index.html, the
// sitemap and canonical tags from this list, and App.js (RouteMeta) applies
// the same titles/descriptions during client-side navigation.
// Keep this in sync with the <Routes> in App.js.
export const SITE_ROUTES = [
  {
    path: "/",
    title: "S & Z Hair and Laser — Luxury Hair Salon & Laser Studio in Brampton",
    description:
      "A private hair and laser studio in Brampton, Ontario. Precision cuts, bespoke colour, medical-grade laser and skin treatments — by appointment only.",
  },
  {
    path: "/about",
    title: "Our Story — S & Z Hair and Laser, Brampton",
    description:
      "An atelier, not a salon: precision craft, a hushed private sanctuary, and medical-grade integrity behind every S & Z appointment in Brampton.",
  },
  {
    path: "/services-hair",
    title: "Hair Services — Cuts, Colour, Balayage & Keratin | S & Z Hair and Laser",
    description:
      "Precision cuts, bespoke colour, balayage, perms, keratin and restorative hair treatments at S & Z Hair and Laser in Brampton, with honest estimated durations.",
  },
  {
    path: "/services-laser",
    title: "Laser & Skin Services | S & Z Hair and Laser, Brampton",
    description:
      "Laser hair removal, microneedling, chemical peels, LED light therapy and brightening facials — medical-grade skin treatments in a private Brampton studio.",
  },
  {
    path: "/gallery",
    title: "Gallery — S & Z Hair and Laser, Brampton",
    description:
      "A closer look at the work we're proud of — hair, colour and skin results from the S & Z studio in Brampton, Ontario.",
  },
  {
    path: "/testimonials",
    title: "Reviews — S & Z Hair and Laser, Brampton",
    description:
      "Live Google reviews for S & Z Hair and Laser in Brampton — kind words from real guests, updated automatically.",
  },
  {
    path: "/contact",
    title: "Contact & Book — S & Z Hair and Laser, Brampton",
    description:
      "Request an appointment at S & Z Hair and Laser, 70 Chesterwood Cres Unit A, Brampton. Call (647) 773-5359 or send the studio an enquiry.",
  },
];

export const NOT_FOUND_META = {
  title: "Page Not Found — S & Z Hair and Laser",
  description:
    "The page you're looking for doesn't exist. Return to the S & Z Hair and Laser homepage.",
};
